<template>
  <nav class="nav-bar">
    <div class="logo">
      <img src="../assets/logo.png" alt="JUEYUAN">
    </div>
    <div class="menu-toggle" @click="toggleMenu">
      <span :class="['hamburger', { 'active': isMenuOpen }]"></span>
    </div>
    <div :class="['nav-links', { 'active': isMenuOpen }]">
      <a href="#" class="active">首页</a>
      <a href="#">产品服务</a>
      <a href="#">客户案例</a>
      <a href="#">会员中心</a>
      <a href="#">关于我们</a>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      document.body.style.overflow = this.isMenuOpen ? 'hidden' : '';
    }
  }
}
</script>

<style scoped>
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 50px;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
}

.logo img {
  height: 30px;
}

.nav-links {
  display: flex;
  gap: 30px;
}

.nav-links a {
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s;
}

.nav-links a:hover,
.nav-links a.active {
  color: #42b983;
}

.menu-toggle {
  display: none;
  width: 24px;
  height: 24px;
  cursor: pointer;
  padding: 0;
  position: relative;
}

.hamburger {
  display: block;
  width: 24px;
  height: 2px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  transition: all 0.3s;
}

.hamburger::before,
.hamburger::after {
  content: '';
  position: absolute;
  width: 24px;
  height: 2px;
  background: #fff;
  transition: all 0.3s;
}

.hamburger::before {
  top: -8px;
}

.hamburger::after {
  bottom: -8px;
}

.hamburger.active {
  background: transparent;
}

.hamburger.active::before {
  transform: rotate(45deg);
  top: 0;
}

.hamburger.active::after {
  transform: rotate(-45deg);
  bottom: 0;
}

@media screen and (max-width: 768px) {
  .nav-bar {
    padding: 40px;
    height: 240px;
    position: relative;
  }

  .logo img {
    height: 88px;
  }

  .menu-toggle {
    display: block;
    width: 160px;
    height: 160px;
    padding: 30px;
    position: absolute;
    right: 40px;
    top: 40px;
  }

  .hamburger {
    width: 100px;
    height: 8px;
  }

  .hamburger::before,
  .hamburger::after {
    width: 100px;
    height: 8px;
  }

  .hamburger::before {
    top: -32px;
  }

  .hamburger::after {
    bottom: -32px;
  }

  .nav-links {
    position: fixed;
    top: 240px;
    left: 0;
    width: 100%;
    height: calc(100vh - 240px);
    background: rgba(0, 0, 0, 0.95);
    flex-direction: column;
    align-items: center;
    padding: 64px 0;
    gap: 48px;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    backdrop-filter: blur(10px);
  }

  .nav-links.active {
    transform: translateX(0);
  }

  .nav-links a {
    font-size: 32px;
    padding: 16px 48px;
    width: 100%;
    text-align: center;
  }
}
</style> 